import { useState, type FormEvent } from 'react';
import { useNavigate } from 'react-router-dom';
import { api, saveToken } from '../api';

export default function LoginPage(): JSX.Element {
  const nav = useNavigate();
  const [tenantId, setTenantId] = useState('');
  const [user, setUser] = useState('');
  const [code, setCode] = useState('');
  const [err, setErr] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  async function submit(e: FormEvent): Promise<void> {
    e.preventDefault();
    setErr(null);
    setLoading(true);
    try {
      const { token } = await api.login(Number(tenantId), user, code);
      saveToken(token);
      nav('/');
    } catch (e) {
      setErr(e instanceof Error ? e.message : String(e));
    } finally {
      setLoading(false);
    }
  }

  return (
    <>
      <div className="header">Entregas <div className="sub">Acceso repartidor</div></div>
      <div className="container">
        <form className="card" onSubmit={submit}>
          {err && <div className="alert error">{err}</div>}
          <div className="label">Empresa (tenant ID)</div>
          <input className="input" value={tenantId} onChange={(e) => setTenantId(e.target.value)}
                 inputMode="numeric" required />
          <div className="label">Usuario</div>
          <input className="input" value={user} onChange={(e) => setUser(e.target.value)} required />
          <div className="label">Código de acceso</div>
          <input className="input" type="password" value={code} onChange={(e) => setCode(e.target.value)} required />
          <button className="btn" disabled={loading}>{loading ? 'Ingresando…' : 'Ingresar'}</button>
        </form>
      </div>
    </>
  );
}
